module.exports = __webpack_public_path__ + "static/img/H2.fb56107.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cowboy/H2.png
// module id = p3pQ
// module chunks = 0